import { xStore } from 'xStore';
import File from '../models/File';
/* eslint-disable no-underscore-dangle */
class CacheService {
	constructor() {
		if (!CacheService.instance) {
			// eslint-disable-next-line new-cap
			this.cache = new xStore('imagecompress', localStorage);
			this.cache.set('files', this.cache.get('files') || []);
			this.cache.set('history', this.cache.get('history') || []);
			CacheService.instance = this;
		}
		return CacheService.instance;
	}
	get HistoryCount() {
		return this.getHistory().length;
	}
	addFiles = files => {
		this._set('files', this._get('files').concat(files));
	}
	getFiles = () => {
		// as functions are not serialized, we have to create the file
		// object again
		const fileCache = this._get('files');
		let files = [];
		if (fileCache && fileCache.length > 0) {
			files = fileCache.map(file => {
				return new File(file.key, file.name, file.size, file.status,
					file.url, file.percentageCompression, file.compressedSize);
			});
		}
		return files;
	}
	clearFiles = () => {
		this._clear('files');
	}
	addHistory = files => {
		this._set('history', this._get('history').concat(files));
	}
	getHistory = () => {
		return this._get('history');
	}
	clearHistory = () => {
		return this._set('history', []);
	}

	_set = (key, data) => {
		this.cache.set(key, data);
	}
	_get = key => {
		return this.cache.get(key);
	}
	_clear = key => {
		this.cache.set(key, []);
	}
}

const instance = new CacheService();
Object.freeze(instance);
export default instance;



// WEBPACK FOOTER //
// ./src/services/CacheService.js